


// import React, { useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { X, Plus, Trash2 } from "lucide-react";
// import AddressPopup from "./AddressPopup";
// import { setShippingAddress, addSavedAddress, removeSavedAddress, removeAllAddresses } from "../../store/addressSlice";

// const SavedAddressesPopup = ({ onClose, onSelectAddress ,setShowSavedAddressesPopup}) => {
//   const dispatch = useDispatch();
//   const savedAddresses = useSelector((state) => state.address.savedAddresses) || [];
//   const shippingAddress = useSelector((state) => state.address.shippingAddress);

//   const [showShippingPopup, setShowShippingPopup] = useState(false);
//   const [selectedIndex, setSelectedIndex] = useState(
//     savedAddresses.findIndex((addr) => JSON.stringify(addr) === JSON.stringify(shippingAddress))
//   );

//   // Handle address selection
//   const handleSelectAddress = (index) => {
//     setSelectedIndex(index);
//     dispatch(setShippingAddress(savedAddresses[index]));
//     onSelectAddress(savedAddresses[index]); // Callback for parent component
//   };

//   // Handle adding a new address
//   const handleAddAddress = (address) => {
//     dispatch(addSavedAddress(address)); // Dispatch action to add new address to savedAddresses
//     dispatch(setShippingAddress(address)); // Optionally set the new address as the shipping address
//     setShowShippingPopup(false); // Close the popup after adding
//   };

//   // Handle removing a saved address
//   const handleRemoveAddress = (index) => {
//     dispatch(removeSavedAddress(index)); // Dispatch action to remove the address from savedAddresses
//     if (savedAddresses.length === 1) {
//       // If the last address is removed, clear the shipping address as well
//       dispatch(setShippingAddress(null));
//     }
//   };

//   // Handle removing all addresses
//   const handleRemoveAllAddresses = () => {
//     dispatch(removeAllAddresses()); // Removes all saved addresses and clears the shipping address
//   };

//   // Render full address in a single block
//   const renderFullAddress = (address) => {
//     return (
//       <p className="text-base">
//         {/* const fullAddress = shippingAddress
//     ? `${shippingAddress.addressLine1}, ${shippingAddress.addressLine2}, ${shippingAddress.city}, ${shippingAddress.state} - ${shippingAddress.postalCode}, ${shippingAddress.country}` */}
    
//         {address.addressLine1}, {address.addressLine2}, {address.city}, {address.state}, {address.zipCode}, {address.country}
//       </p>
//     );
//   };

//   const handleOpenClose=()=>{
//     setShowSavedAddressesPopup(false);
//     setShowShippingPopup(true);
    
//   }

//   return (
//     <div className="fixed inset-0  bg-opacity-50 flex items-center justify-center z-30">
//       <div className="bg-tertiary p-6 rounded-md shadow-lg w-[90%] lg:w-[70%] xl:w-[40%] z-90">
//         {/* Header */}
//         <div className="flex justify-between items-center">
//           <h2 className="text-lg font-semibold">Saved Addresses</h2>
//           <X className="cursor-pointer" onClick={onClose} />
//         </div>
//         <hr className="my-2 border-gray-300" />

//         {/* Add Address */}
//         <div className="flex items-center text-blue-600 cursor-pointer justify-start">
//           <Plus className="mr-2" size={20} />
//           <p
//             className="py-2  text-primary1 text-center font-light text-lg font-outfit "
//             onClick={() => handleOpenClose()}
//           >
//             Add Address
//           </p>
//         </div>
//         <hr className="my-2 border-gray-300" />

//         {/* Saved Addresses List */}
//         <div className="mt-2">
//           {savedAddresses.length > 0 ? (
//             savedAddresses.map((address, index) => (
//               <div
//                 key={index}
//                 className={`flex items-center border-b py-2 px-2 cursor-pointer hover:bg-gray-100 rounded ${
//                   selectedIndex === index ? "border-blue-500" : ""
//                 }`}
//                 onClick={() => handleSelectAddress(index)}
//               >
//                 <input
//                   type="radio"
//                   checked={selectedIndex === index}
//                   onChange={() => handleSelectAddress(index)}
//                   className="mr-3 w-4 h-4"
//                 />
//                 <div className="w-full text-poppins font-light text-hcolor">
//                   <p className="font-light font-outfit text-xl text-primary1">{address.name}({address.saveAddressAs})</p>
//                   {renderFullAddress(address)}
//                   <p className="text-base">{address.email}</p>
//                   <p className="text-base">{address.phone}</p>
//                   {/* Full address displayed */}
                 
//                 </div>
                
//                 {/* Clear Address Button */}
//                 <button
//                   className="px-3 py-1 bg-red-500 text-white text-sm rounded ml-2"
//                   onClick={(e) => {
//                     e.stopPropagation(); // Prevent triggering address selection
//                     handleRemoveAddress(index);
//                   }}
//                 >
//                   <Trash2 size={16} className="mr-2" />
//                 </button>
//               </div>
//             ))
//           ) : (
//             <p className="text-gray-500 text-sm text-center mt-4">
//               No saved addresses yet.
//             </p>
//           )}
//         </div>

//         {/* Remove All Button */}
//         {savedAddresses.length > 0 && (
//           <div className="mt-4 text-center">
//             <button
//               onClick={handleRemoveAllAddresses}
//               className="px-4 py-2 bg-red-600 text-white rounded"
//             >
//               Remove All Addresses
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Shipping Address Popup */}
//       {showShippingPopup && (
//         <AddressPopup
//           onClose={() => setShowShippingPopup(false)}
//           onSubmit={handleAddAddress} // Pass handleAddAddress as the onSubmit handler
//         />
//       )}
//     </div>
//   );
// };

// export default SavedAddressesPopup;

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { X, Plus, Trash2 } from "lucide-react";
import AddressPopup from "./AddressPopup";
import { 
  setShippingAddress, 
  addNewAddress, 
  removeSavedAddress, 
  fetchAddresses, 
  deleteAddress 
} from "../../store/addressSlice";

const SavedAddressesPopup = ({ onClose, onSelectAddress }) => {
  const dispatch = useDispatch();
  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    if (authToken) {
      dispatch(fetchAddresses());
    }
  }, [dispatch, authToken]);

  const savedAddresses = useSelector((state) => state.address.savedAddresses);
  const shippingAddress = useSelector((state) => state.address.shippingAddress);

  const [showShippingPopup, setShowShippingPopup] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(
    savedAddresses.findIndex((addr) => JSON.stringify(addr) === JSON.stringify(shippingAddress))
  );

  useEffect(() => {
    if (selectedIndex >= 0) {
      dispatch(setShippingAddress(savedAddresses[selectedIndex]));
    }
  }, [selectedIndex, dispatch, savedAddresses]);

  const handleSelectAddress = (index) => {
    setSelectedIndex(index);
    dispatch(setShippingAddress(savedAddresses[index]));
    onSelectAddress(savedAddresses[index]); // Callback for parent component
  };

  const handleAddAddress = (address) => {
    dispatch(addNewAddress(address));
    dispatch(setShippingAddress(address));
    setShowShippingPopup(false);
  };

  const handleRemoveAddress = async (addressId) => {
    if (!addressId) {
      console.error("Error: Address ID is missing!");
      return;
    }
  
    try {
      await dispatch(deleteAddress(addressId)).unwrap();
  
      // If the deleted address was the shipping address, reset it
      if (shippingAddress && shippingAddress.id === addressId) {
        dispatch(setShippingAddress(null));
      }
    } catch (error) {
      console.error("Failed to delete address:", error);
    }
  };
  

  return (
    <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center z-30">
      <div className="bg-tertiary p-6 rounded-md shadow-lg w-[90%] lg:w-[70%] xl:w-[40%] z-90">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold">Saved Addresses</h2>
          <X className="cursor-pointer" onClick={onClose} />
        </div>
        <hr className="my-2 border-gray-300" />
        <div className="flex items-center text-blue-600 cursor-pointer justify-start">
          <Plus className="mr-2" size={20} />
          <p
            className="py-2 text-primary1 text-center font-light text-lg font-outfit"
            onClick={() => setShowShippingPopup(true)}
          >
            Add Address
          </p>
        </div>
        <hr className="my-2 border-gray-300" />
        <div className="mt-2 max-h-60 overflow-y-auto border-t border-b border-gray-300">
          {savedAddresses.length > 0 ? (
            savedAddresses.map((address, index) => (
              <div
                key={address.id} // Use the unique address ID
                className={`flex items-center border-b py-2 px-2 cursor-pointer hover:bg-gray-100 rounded ${
                  selectedIndex === index ? "border-blue-500" : ""
                }`}
                onClick={() => handleSelectAddress(index)}
              >
                <input
                  type="radio"
                  checked={selectedIndex === index}
                  onChange={() => handleSelectAddress(index)}
                  className="mr-3 w-4 h-4"
                />
                <div className="w-full text-poppins font-light text-hcolor">
                  <p className="font-light font-outfit text-xl text-primary1">
                    {address.firstName} {address.lastName} ({address.saveAddressAs})
                  </p>
                  <p>
                    {address.houseNumber}, {address.area}, {address.city}, {address.state}, {address.pincode}, {address.country}
                  </p>
                  <p>{address.email}</p>
                  <p>{address.phone}</p>
                </div>
                <button
  className="px-3 py-1 bg-red-500 text-white text-sm rounded ml-2"
  onClick={(e) => {
    e.stopPropagation();
    console.log("Deleting address with ID:", address._id); // Debugging log
    handleRemoveAddress(address._id);
  }}
>
  <Trash2 size={16} className="mr-2" />
</button>

              </div>
            ))
          ) : (
            <p className="text-gray-500 text-sm text-center mt-4">No saved addresses yet.</p>
          )}
        </div>
      </div>
      {showShippingPopup && (
        <AddressPopup
          onClose={() => setShowShippingPopup(false)}
          onSubmit={handleAddAddress}
        />
      )}
    </div>
  );
};

export default SavedAddressesPopup;
